import {
  Alert,
  Box,
  List,
  ListItem,
  ListItemText,
  Skeleton,
  useTheme,
} from "@mui/material";
import * as React from "react";

import { useCurrentOrgId } from "@/providers/auth/hooks";
import {
  UpdateDeviceTags,
  UpdateDeviceMetadata,
} from "@/shared/components/devices";
import { RobotoPrincipalUnderlineLink } from "@/shared/components/principal";
import { useDevice } from "@/shared/domain/devices/hooks/useDevice";

interface DeviceDetailsProps {
  deviceId: string;
}

export const DeviceDetails: React.FC<DeviceDetailsProps> = ({ deviceId }) => {
  const theme = useTheme();
  const currentOrgId = useCurrentOrgId();
  const deviceQuery = useDevice(deviceId, currentOrgId);

  const device = deviceQuery.data;

  const dataLoading = deviceQuery.isLoading;

  return (
    <>
      {!device && dataLoading && (
        <Box marginTop={theme.spacing(2)}>
          <Skeleton variant="rounded" height="300px" />
        </Box>
      )}

      {deviceQuery.error && (
        <Box
          sx={{
            marginTop: theme.spacing(2),
            marginBottom: theme.spacing(2),
          }}
        >
          <Alert severity="error">{deviceQuery.error.message}</Alert>
        </Box>
      )}

      {device && !dataLoading && (
        <Box>
          <List sx={{ width: "100%" }} disablePadding>
            <ListItem>
              <ListItemText
                primary={"Device ID"}
                secondary={device.device_id}
              />
            </ListItem>
            <ListItem>
              <ListItemText
                primary={"Created"}
                secondary={new Date(device.created).toLocaleString()}
              />
            </ListItem>
            <ListItem>
              <ListItemText
                primary={"Created By"}
                secondary={
                  <RobotoPrincipalUnderlineLink
                    principal={device.created_by}
                    icon
                  />
                }
              />
            </ListItem>
            <ListItem>
              <ListItemText
                primary={"Modified"}
                secondary={new Date(device.modified).toLocaleString()}
              />
            </ListItem>
            <ListItem>
              <ListItemText
                primary={"Modified By"}
                secondary={
                  <RobotoPrincipalUnderlineLink
                    principal={device.modified_by}
                    icon
                  />
                }
              />
            </ListItem>
            <ListItem>
              <ListItemText
                primary={"Tags"}
                secondary={
                  currentOrgId ? (
                    <UpdateDeviceTags
                      device={device}
                      resourceOwnerId={currentOrgId}
                    />
                  ) : (
                    "Loading..."
                  )
                }
              />
            </ListItem>
            <ListItem>
              <ListItemText
                primary={"Metadata"}
                secondary={
                  currentOrgId ? (
                    <UpdateDeviceMetadata
                      device={device}
                      resourceOwnerId={currentOrgId}
                    />
                  ) : (
                    "Loading..."
                  )
                }
              />
            </ListItem>
          </List>
        </Box>
      )}
    </>
  );
};
